<script>
  export let size = 32;
  export let color = "#319ED7";
  export let className = "";
</script>

<svg
  height={size}
  viewBox="0 0 376 108"
  fill="none"
  aria-label="Nomie Logo"
  class="{className} nomie-logo wordmark"
  xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M63.9958 40.8859C68.1747 45.8904 70.2642 53.4456 70.2642
    63.5517V97.2225C70.2642 100.429 69.268 102.956 67.2757 104.802C65.2835
    106.648 62.5866 107.571 59.1852 107.571C55.7837 107.571 53.1112 106.648
    51.1675 104.802C49.2238 102.956 48.2519 100.429 48.2519
    97.2225V64.5721C48.2519 59.7133 47.353 56.1665 45.5551 53.9315C43.7572
    51.6965 40.9631 50.579 37.1729 50.579C32.6053 50.579 28.9366 52.0366 26.1668
    54.9518C23.3971 57.867 22.0122 61.754 22.0122 66.6127V97.2225C22.0122
    100.429 21.0404 102.956 19.0967 104.802C17.153 106.648 14.4805 107.571
    11.079 107.571C7.67753 107.571 4.9807 106.648 2.98841 104.802C0.996128
    102.956 0 100.429 0 97.2225V43.7282C0 40.7158 1.04472 38.2865 3.13419
    36.4402C5.22366 34.5939 7.92049 33.6707 11.2248 33.6707C14.2375 33.6707
    16.6914 34.5696 18.5865 36.3673C20.4816 38.165 21.4291 40.4729 21.4291
    43.291V45.3316C23.9559 41.4446 27.2358 38.4808 31.269 36.4402C35.3022
    34.3995 39.8455 33.3792 44.8991 33.3792C53.4513 33.3792 59.8168 35.8814
    63.9958 40.8859ZM92.9735 103.272C87.2396 100.211 82.8178 95.8864 79.7079
    90.2988C76.598 84.7113 75.043 78.1278 75.043 70.5482C75.043 62.9686 76.598
    56.3852 79.7079 50.7976C82.8178 45.2101 87.2396 40.9102 92.9735
    37.8978C98.7074 34.8854 105.364 33.3792 112.945 33.3792C120.525 33.3792
    127.182 34.8854 132.916 37.8978C138.65 40.9102 143.072 45.2101 146.182
    50.7976C149.292 56.3852 150.847 62.9686 150.847 70.5482C150.847 78.1278
    149.292 84.7113 146.182 90.2988C143.072 95.8864 138.65 100.211 132.916
    103.272C127.182 106.333 120.525 107.863 112.945 107.863C105.364 107.863
    98.7074 106.333 92.9735 103.272ZM128.98 70.5482C128.98 63.6489 127.595
    58.4987 124.826 55.0976C122.056 51.6965 118.096 49.996 112.945
    49.996C102.255 49.996 96.9095 56.8467 96.9095 70.5482C96.9095 84.2498
    102.255 91.1005 112.945 91.1005C123.635 91.1005 128.98 84.2498 128.98
    70.5482ZM261.318 40.4486C265.497 45.1616 267.586 52.8625 267.586
    63.5517V97.2225C267.586 100.624 266.566 103.199 264.525 104.948C262.484
    106.697 259.86 107.571 256.653 107.571C253.543 107.571 250.919 106.697
    248.781 104.948C246.643 103.199 245.574 100.624 245.574
    97.2225V63.2602C245.574 58.5958 244.772 55.3162 243.169 53.4213C241.565
    51.5264 239.112 50.579 235.807 50.579C231.725 50.579 228.47 51.988 226.04
    54.8061C223.611 57.6241 222.396 61.5596 222.396 66.6127V97.2225C222.396
    100.624 221.375 103.199 219.335 104.948C217.294 106.697 214.67 107.571
    211.463 107.571C208.353 107.571 205.729 106.697 203.591 104.948C201.453
    103.199 200.384 100.624 200.384 97.2225V63.2602C200.384 58.5958 199.582
    55.3162 197.978 53.4213C196.375 51.5264 193.921 50.579 190.617
    50.579C186.535 50.579 183.279 51.988 180.85 54.8061C178.42 57.6241 177.205
    61.5596 177.205 66.6127V97.2225C177.205 100.624 176.16 103.199 174.071
    104.948C171.982 106.697 169.382 107.571 166.272 107.571C163.162 107.571
    160.538 106.697 158.4 104.948C156.262 103.199 155.193 100.624 155.193
    97.2225V43.7282C155.193 40.5215 156.286 38.0436 158.473 36.2944C160.66
    34.5453 163.308 33.6707 166.418 33.6707C169.333 33.6707 171.763 34.521
    173.707 36.2216C175.65 37.9221 176.622 40.2785 176.622
    43.291V44.7486C178.955 41.0559 181.991 38.2379 185.733 36.2944C189.475
    34.3509 193.726 33.3792 198.489 33.3792C203.639 33.3792 207.988 34.4238
    211.535 36.5131C215.083 38.6023 217.828 41.9791 219.772 46.6435C222.007
    42.5621 225.19 39.3312 229.32 36.9504C233.451 34.5696 238.14 33.3792 243.388
    33.3792C251.162 33.3792 257.139 35.7357 261.318 40.4486ZM276.534
    104.948C274.445 103.199 273.4 100.624 273.4 97.2225V44.0198C273.4 40.6187
    274.469 38.0436 276.607 36.2944C278.745 34.5453 281.369 33.6707 284.479
    33.6707C287.589 33.6707 290.188 34.5453 292.278 36.2944C294.367 38.0436
    295.412 40.6187 295.412 44.0198V97.2225C295.412 100.624 294.367 103.199
    292.278 104.948C290.188 106.697 287.589 107.571 284.479 107.571C281.272
    107.571 278.624 106.697 276.534 104.948ZM275.295 20.9819C273.06 18.7845
    271.942 15.8101 271.942 12.0585C271.942 8.30697 273.06 5.35936 275.295
    3.21561C277.53 1.07185 280.591 0 284.479 0C288.269 0 291.306 1.09864 293.59
    3.29599C295.874 5.49334 297.016 8.41415 297.016 12.0585C297.016 15.8101
    295.898 18.7845 293.663 20.9819C291.428 23.1792 288.366 24.2779 284.479
    24.2779C280.591 24.2779 277.53 23.1792 275.295 20.9819ZM365.431
    87.748C366.645 89.3028 367.253 91.2949 367.253 93.7242C367.253 95.3762
    366.767 96.9066 365.795 98.3157C364.823 99.7247 363.463 100.915 361.713
    101.887C358.409 103.636 354.57 105.069 350.197 106.187C345.824 107.304
    341.79 107.863 338.097 107.863C330.323 107.863 323.544 106.357 317.762
    103.344C311.979 100.332 307.533 96.0321 304.423 90.4446C301.313 84.8571
    299.758 78.2736 299.758 70.694C299.758 63.4059 301.265 56.9439 304.277
    51.3078C307.29 45.6717 311.469 41.2746 316.814 38.1165C322.159 34.9583
    328.233 33.3792 335.036 33.3792C341.548 33.3792 347.257 34.8125 352.165
    37.6792C357.073 40.5458 360.887 44.6271 363.608 49.9231C366.33 55.2191
    367.69 61.4138 367.69 68.5076C367.69 70.6454 367.18 72.2731 366.159
    73.3906C365.139 74.5081 363.706 75.0668 361.859 75.0668H321.042C321.722
    80.8001 323.471 84.9542 326.29 87.5294C329.108 90.1045 333.141 91.392
    338.389 91.392C341.207 91.392 343.734 91.0519 345.969 90.3717C348.205
    89.6915 350.683 88.7684 353.404 87.6023C354.765 87.0192 356.077 86.5091
    357.34 86.0718C358.603 85.6345 359.721 85.4158 360.693 85.4158C362.637
    85.4158 364.216 86.1932 365.431 87.748ZM325.561 52.5468C323.034 55.2191
    321.528 59.0817 321.042 64.1348H349.176C348.885 58.9845 347.597 55.0976
    345.313 52.4739C343.03 49.8502 339.798 48.5384 335.619 48.5384C331.44
    48.5384 328.088 49.8745 325.561 52.5468ZM363.349 33.1092C363.349 33.9515
    363.511 34.7506 363.835 35.5065C364.16 36.2624 364.603 36.9265 365.165
    37.4988C365.728 38.0711 366.387 38.5193 367.144 38.8432C367.901 39.1672
    368.712 39.3292 369.577 39.3292C370.442 39.3292 371.253 39.1672 372.01
    38.8432C372.767 38.5193 373.427 38.0711 373.989 37.4988C374.551 36.9265
    374.995 36.2624 375.319 35.5065C375.643 34.7506 375.806 33.9515 375.806
    33.1092C375.806 32.2453 375.643 31.4354 375.319 30.6795C374.995 29.9236
    374.551 29.2649 373.989 28.7033C373.427 28.1418 372.767 27.6991 372.01
    27.3751C371.253 27.0512 370.442 26.8892 369.577 26.8892C368.712 26.8892
    367.901 27.0512 367.144 27.3751C366.387 27.6991 365.728 28.1418 365.165
    28.7033C364.603 29.2649 364.16 29.9236 363.835 30.6795C363.511 31.4354
    363.349 32.2453 363.349 33.1092ZM372.886 36.0027C372.886 36.1819 372.814
    36.3292 372.67 36.4445C372.526 36.5597 372.358 36.6173 372.165
    36.6173C372.044 36.6173 371.925 36.5885 371.81 36.5309C371.695 36.4733
    371.599 36.3836 371.522 36.262L370.254 34.3798C370.145 34.2133 370.03
    34.0932 369.908 34.0196C369.787 33.946 369.633 33.9092 369.447
    33.9092H368.67V35.8491C368.67 36.0795 368.604 36.262 368.473 36.3964C368.341
    36.5309 368.164 36.5981 367.94 36.5981C367.709 36.5981 367.527 36.5309
    367.392 36.3964C367.258 36.262 367.19 36.0795 367.19 35.8491V30.4712C367.19
    30.2471 367.251 30.0743 367.373 29.9526C367.495 29.831 367.668 29.7702
    367.892 29.7702H370.302C371.096 29.7702 371.697 29.9446 372.103
    30.2935C372.51 30.6425 372.713 31.1466 372.713 31.8061C372.713 32.3246
    372.569 32.7568 372.281 33.1025C371.993 33.4482 371.586 33.6755 371.061
    33.7843C371.253 33.8227 371.424 33.898 371.575 34.01C371.725 34.122 371.871
    34.2837 372.012 34.495L372.742 35.5898C372.838 35.7306 372.886 35.8682
    372.886 36.0027ZM371.013 32.5503C371.205 32.3999 371.301 32.1646 371.301
    31.8445C371.301 31.518 371.205 31.2811 371.013 31.1339C370.821 30.9866
    370.51 30.913 370.081 30.913H368.65V32.776H370.081C370.51 32.776 370.821
    32.7008 371.013 32.5503Z"
    fill={color} />
</svg>
